module.exports = __webpack_public_path__ + "img/calendar.38a3c47a.png";